import React, {
  createContext,
  useState,
  useContext,
  useRef,
  useEffect,
} from "react";
import { useProducts } from "./ProductContext";

const CategoryContext = createContext();

export function useCategory() {
  return useContext(CategoryContext);
}

export function CategoryProvider({ children }) {
  const productListRef = useRef(null);
  const [selectedCategory, setSelectedCategory] = useState("All Products");
  const [searchQuery, setSearchQuery] = useState("");
  const { fetchProducts } = useProducts();

  // Scroll to the Product List section with an offset
  const handleCategoryClick = (category) => {
    setSelectedCategory(category);
    if (productListRef.current) {
      const offset = 100;
      const elementPosition =
        productListRef.current.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;

      window.scrollTo({
        top: offsetPosition,
        behavior: "smooth",
      });
    } else {
      console.log("productListRef is null");
    }
  };

  // Handle changes to the search query (on every keystroke)
  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value);
  };

  useEffect(() => {
    const storedQuery = localStorage.getItem("searchQuery");
    if (storedQuery) {
      setSearchQuery(storedQuery);
    }
  }, []);

  // Trigger the API call when the Enter key is pressed or search button is clicked
  const handleSearchSubmit = (event) => {
    event.preventDefault();

    localStorage.setItem("scrollToProductList", "true");

    if (searchQuery.trim() !== "") {
      // Store search query in localStorage
      localStorage.setItem("searchQuery", searchQuery);
    } else {
      // Remove search query if empty
      localStorage.removeItem("searchQuery");
    }

    if (window.location.pathname !== "/") {
      // Redirect to home page with search query in URL
      window.location.href = `/?q=${encodeURIComponent(searchQuery.trim())}`;
    } else {
      // If already on home, directly fetch products
      fetchProducts("", searchQuery.trim(), true, searchQuery.trim() !== "");
      handleCategoryClick(selectedCategory);
    }
  };

  return (
    <CategoryContext.Provider
      value={{
        selectedCategory,
        setSelectedCategory, // Allow changing the category
        handleCategoryClick,
        productListRef,
        searchQuery, // Provide the search query to other components
        setSearchQuery, // Function to update the search query
        handleSearchChange, // Function to handle search input change
        handleSearchSubmit, // Function to trigger API search
      }}
    >
      {children}
    </CategoryContext.Provider>
  );
}
